/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Component, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UserService, AccountService} from '../../../../services';
import {environment} from '../../../../../environments/environment';
import {User, Helpers} from '../../../../model';
import {UserProvider} from '../../../../providers';
import { CrmAlertComponent } from 'src/app/components/fields';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ChangePasswordModal } from 'src/app/components/modal';
import { Subject } from 'rxjs';
import { LogService } from 'src/app/services';

@Component({
  selector: 'app-page-preferences',
  templateUrl: 'preferences.page.html',
  styleUrls: ['preferences.page.scss']
})

export class PreferencesPage implements OnInit, OnDestroy {
  @ViewChild('alert') alert: CrmAlertComponent;
  chromeAppInstalled: boolean;
  private chromeAppSub: any;

  user: User;
  private userSub: any;
  saveSub: any;
  changeSub: any;
  changeModal: BsModalRef;

  constructor(
    private userService: UserService,
    private userProvider: UserProvider,
    private ngZone: NgZone,
    private accountService: AccountService,
    private modalService: BsModalService,
    private logService :LogService
  ) {
    this.saveSub = this.accountService.onSavePreferences.subscribe(() => {
      this.onSave();
    });


    this.changeSub = this.accountService.onChangePassword.subscribe(() => {
      this.onChange();
    });
  }

  ngOnInit(): void {
    this.chromeAppSub = this.userService.extensionState$.subscribe(extState => this.chromeAppInstalled = extState);
    this.userSub = this.userService.user$.subscribe(u => this.user = u);
  }

  ngOnDestroy(): void {
    if (this.chromeAppSub) this.chromeAppSub.unsubscribe();
    if (this.userSub) this.userSub.unsubscribe();
    if (this.saveSub) this.saveSub.unsubscribe();
    if (this.changeSub) this.changeSub.unsubscribe();
  }

  pickFolder(): void {
    if (this.chromeAppInstalled) {
      try {
        // @ts-ignore
        chrome.runtime.sendMessage(environment.CHROME_APP, {
          action: 'chooseFolder'
        }, response => {
          if (response) {
            if (response.path) {
              this.ngZone.run( () => {
                this.user.WORKING_DIRECTORY = response.path;
              });

              /* this.userProvider.save(this.user.ID, 'WORKING_DIRECTORY', response.path)
                .subscribe(data => {
                  if (!data.success)
                    this.logService.error(JSON.stringify(data, null, 2));
                }); */
            }
          }
        });
      } catch (e) {
        this.logService.error(e);
      }
    }
  }

  onSave(): void {
    this.alert.hide();
    if (this.user.WORKING_DIRECTORY) {
      this.userProvider.save(this.user.ID, 'WORKING_DIRECTORY', this.user.WORKING_DIRECTORY)
        .subscribe(data => {
          if (data.success) {
            this.alert.showSuccess('You successfully changed your working directory.');
            setTimeout(() => {
              this.alert.hide();
            }, 3000);
          }
        });
    }
  }

  onChange(): void {
    this.alert.hide();
    this.changeModal = this.modalService.show(ChangePasswordModal, Helpers.getModalConfig());
    const ackSubject = new Subject<boolean>();
    this.changeModal.content.subject = ackSubject;
    this.changeModal.content.user = this.user;

    ackSubject.subscribe(value => {
      if (value) {
        this.alert.showSuccess('You successfully changed your passwod.');

        setTimeout(() => {
          this.alert.hide();
        }, 3000);
      }
    });
  }
}
